<style src="./RawContent.scss" lang="scss"></style>

<template lang="pug">
  .raw-content(
    v-html='content'
  )
</template>

<script>
export default {
  props: ["content"]
};
</script>
